export const DIALOG_CONFIG = {
  minWidth: '300px',
  width: '400px',
  enterAnimationDuration: '500ms',
  exitAnimationDuration: '500ms',
  disableClose: false,
  backdropClass: 'userActivationDialog'
};
